import { useEffect, useRef, useState } from 'react';
import { OrderResponse } from 'api/models';

type UseCheckoutComment = {
  comment?: OrderResponse['comment'];
};

export const useCheckoutComment = ({ comment }: UseCheckoutComment) => {
  const [orderComment, setOrderComment] = useState(comment || '');
  const methods = useRef<{ focus: VoidFunction } | null>(null);

  useEffect(() => {
    setOrderComment(comment || '');
  }, [comment]);

  return { orderComment, setOrderComment, checkoutCommentMethods: methods };
};
